import React from 'react';
import { StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import AppSnackbarProvider from '../Snackbar/AppSnackbarProvider';
import jss from '../styles/jss';

const withAppTheme = (theme) => (Component) => (props) =>
  (
    <ThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        <StylesProvider jss={jss}>
          <AppSnackbarProvider maxSnack={3}>
            <Component {...props} />
          </AppSnackbarProvider>
        </StylesProvider>
      </StyledThemeProvider>
    </ThemeProvider>
  );

export default withAppTheme;
